import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

export const RequestContentButton = styled.button`
    background: ${p => p.theme.playColor};
    font-size: 14px;
    font-weight: 500;
    color: ${p => p.theme.bgColor};
    padding: 17px 38px;
    border-radius: 9px;
    border: none;
    outline: none;
    display: block;
    margin: 70px auto 20px auto;
    box-shadow: 0px 8px 30px rgba(3, 155, 229, 0.29);
    font-family: inherit;
    cursor: pointer;

    ${cssMediaQueryBreakpoints.medium} {
        padding: 13px;
    }
`
